import React, { useEffect, useState, useRef } from 'react';
import { useMap } from 'react-leaflet/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { selectRandom, selectNext, selectPrevious } from './MyMap.js';
import { fetchData } from './redux/data/dataActions';
import contract from './redux/config/config.json';
import configuration from '../data/config.json';
import polygonJson from '../data/geo_json_string.json';
import { IoIosClose, IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { CgSoftwareDownload } from 'react-icons/cg';
import { TiArrowShuffle } from 'react-icons/ti';
import { NumericFormat } from 'react-number-format';
import { IoCopyOutline } from 'react-icons/io5';
import '../styles/popout.css';
import ownership_full from '../data/availability_list.json';
import token_dict from '../data/token_dict.json';
import { IoIosAdd, IoIosRemove } from 'react-icons/io';

import { Alchemy, Network } from 'alchemy-sdk';
import Web3 from 'web3';
import TokenProgress from './TokenProgress.js';

import { StandardMerkleTree } from '@openzeppelin/merkle-tree';
import merkle_tree from '../data/tree.json';

const contractABI = require('./contract-abi.json');
//const contractAddress = String(contract.CONTRACT_ADDRESS);
const { createAlchemyWeb3 } = require('@alch/alchemy-web3');
var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var opensea_key;

var video_path = '';

//old goerli, "0xcfD9032301Fd10aBc9BD2Cc701F4881be78f1809"
if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  opensea_key = contract.OPENSEA_KEY;
}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = "eth-sepolia"; //Network.ETH_SEPOLIA;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  opensea_key = contract.OPENSEA_KEY;
}

const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

var copyFadeOutTimer = null;
var copyHideTimer = null;

function getNum(numString) {
  let num = numString.split('-')[1];
  return num;
}
function getPrice(numString) {
  return parseInt(numString, 10) * 0.00000025;
}

function getWidth(numString) {
  return Math.sqrt(parseInt(numString, 10));
}

function getTriptych(currentTile) {
  let triptych =
    polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
      .features[0].properties.triptych;
  return triptych;
}
function getLabel(currentTile) {
  let label =
    polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
      .features[0].properties.tile_label;
  return label;
}
function getPackage(currentTile) {
  let package1 =
    polygonJson.features[0].features[parseInt(getNum(currentTile.name))]
      .features[0].properties.collector_package;
  return package1;
}
function constructIPFSLink(currentTile) {
      const baseUrl = "https://ipfs.io/ipfs/";
      let ipfshash;

      // Split the name to get the first word
      const firstWord = currentTile.name.split('-')[0];

      // Determine the token based on the first word
      switch (firstWord) {
          case "classA":
              ipfshash = "QmRtraEinRfHWNqm8pbqZ9UK2WAxxbLqjgxqrGyzCDsNHK";
              break;
          case "classB":
              ipfshash = "QmYN5143vWmcSsBSTg9MREpsLCmHDBooAt7GXSKfmioAgR";
              break;
          case "classC":
              ipfshash = "QmYEK67k2tb95qb8J5p6dVJ4Tposq4LMvpik7j6ax5wzYK";
              break;
          case "classD":
              ipfshash = "QmWNT226FFtBkyi4RroH9rs1roBfLFACPri6kbpFi6aqaN";
              break;
          default:
              ipfshash = ""; // Default case if no class matches
      }

      const secondWord = currentTile.name.split('-')[1] || "";
      const finalUrl = baseUrl + ipfshash + "/TODEM." + secondWord + ".collector_package.zip";
      return finalUrl;
}
const getDimensions = (geometry) => {
  return [
    geometry.coordinates[0][3][0] - geometry.coordinates[0][0][0],
    geometry.coordinates[0][0][1] - geometry.coordinates[0][1][1],
  ];
};
//functions to help with rendering prompt/subtile selection
function findNewScale(currentPrompt, currentTile_name) {
  let og_height = getDimensions(
    polygonJson.features[0].features[parseInt(getNum(currentTile_name))]
      .features[0].geometry
  )[1];
  let new_height = document
    .getElementById('popout-video')
    .getBoundingClientRect().height;
  let ratio = new_height / og_height;
  return ratio;
}
//functions to help with rendering prompt/subtile selection
function getTranslation(currentPrompt, currentTile_name) {
  let parent_top_left =
    polygonJson.features[0].features[parseInt(getNum(currentTile_name))]
      .features[0].geometry.coordinates[0][0];
  let child_top_left = currentPrompt[2].coordinates[0][0];
  return [
    child_top_left[0] - parent_top_left[0],
    parent_top_left[1] - child_top_left[1],
  ];
}
//functions to help with rendering prompt/subtile selection
function drawSubRegionBox(currentPrompt, currentTile_name) {
  let r = findNewScale(currentPrompt, currentTile_name);
  let topLeft = [
    getTranslation(currentPrompt, currentTile_name)[0] * r,
    getTranslation(currentPrompt, currentTile_name)[1] * r,
  ];
  let size = [
    getDimensions(currentPrompt[2])[0] * r,
    getDimensions(currentPrompt[2])[1] * r,
  ];
  return [topLeft[0], topLeft[1], size[0], size[1]];
}
//functions to help with rendering prompt/subtile selection
function renderPromptBox(currentPrompt, currentTile_name, currentTile) {
  let box = drawSubRegionBox(currentPrompt, currentTile_name);
  var vidbox = document.getElementsByClassName('subregion-video-box-popout')[0];
  vidbox.style.display = 'block';
  vidbox.style.color = configuration.subtile_hover_color; //subtile_hover_color

  const container = document.getElementsByClassName('vid-formatter')[0];
  const videoElement = document.getElementsByClassName('popout-video2')[0];
  const containerRect = container.getBoundingClientRect();
  const videoRect = videoElement.getBoundingClientRect();

  // Get the width and height of the video content
  let videoWidth = videoElement.videoWidth;
  let videoHeight = videoElement.videoHeight;

  // Calculate the aspect ratios of the video and the container
  // let videoAspectRatio = videoWidth / videoHeight;
  let videoAspectRatio = currentTile.dimensions[0] / currentTile.dimensions[1];

  let containerAspectRatio = videoRect.width / videoRect.height;

  let contentWidth = 0;
  let contentHeight = 0;
  let leftOffset = 0;
  if (containerAspectRatio > videoAspectRatio) {
    contentHeight = videoRect.height;
    contentWidth = contentHeight * videoAspectRatio;
    leftOffset = (videoRect.width - contentWidth) / 2;
  }

  let translate = 'translate(';
  let translatetxt = translate.concat(
    String(parseInt(box[0]) + leftOffset),
    'px,',
    String(parseInt(box[1])),
    'px)'
  );
  vidbox.style.transform = translatetxt;

  vidbox.style.width = String(box[2]) + 'px';
  vidbox.style.height = String(box[3]) + 'px';
}
//functions to help with rendering prompt/subtile selection
function dissapearPromptBox(currentPrompt, currentTile_name) {
  var vidbox = document.getElementsByClassName('subregion-video-box-popout')[0];
  vidbox.style.display = 'none';
}

function get_aspect_ratio(currentTile_name) {
  let dims = getDimensions(
    polygonJson.features[0].features[parseInt(getNum(currentTile_name))]
      .features[0].geometry
  );
  if (dims[0] >= dims[1]) {
    return 'width';
  } else {
    return 'height';
  }
}
//functions to help with rendering prompt/subtile selection
function isIsolatedWord(str, word) {
  const index = str.toLowerCase().indexOf(word.toLowerCase());
  if (index === -1) {
    return false;
  }
  const before = index === 0 ? ' ' : str.charAt(index - 1);
  const after =
    index + word.length === str.length ? ' ' : str.charAt(index + word.length);
  return !/\w/.test(before) && !/\w/.test(after);
}
//functions to help with rendering prompt/subtile selection
function findMatchingSubstring(str1, str2) {
  if (
    str1 === str2 ||
    str1.toLowerCase() === str2 ||
    str1.toUpperCase() === str2
  ) {
    return str1;
  }
  const str2Lower = str2.toLowerCase();
  if (str1.toLowerCase().includes(str2Lower) || str1.includes(str2)) {
    const index = str1.toLowerCase().search(new RegExp(`${str2Lower}|${str2}`));
    return str1.slice(index, index + str2.length);
  }
  return null;
}
//functions to help with rendering prompt/subtile selection
function colorWiki(textElement, currentPrompt, currentTile, ownership) {
  if (currentPrompt !== null) {
    var textContent = textElement.textContent;
    const modifiedString = String(currentPrompt).replace(/\s+/g, '_');
    let link = 'https://en.wikipedia.org/wiki/' + modifiedString;
    var link_color;
    if (ownership[currentTile.tokenId] == 2) {
      link_color = configuration.yours_hyperlink_color;
    } else if (ownership[currentTile.tokenId] == 1) {
      link_color = configuration.owned_hyperlink_color;
    } else {
      link_color = configuration.sidebar_hyperlink_color;
    }
    if (currentPrompt !== null) {
      if (textContent.includes(currentPrompt)) {
        // Highlight the phrase with RGB(38,252,57)
        var greentext =
          '<a style="text-decoration: none; color:' +
          link_color +
          '" ' +
          'href='.concat(link, ' rel="noreferrer" target="_blank">');
        greentext = greentext.concat(String(currentPrompt), '</a>');
        textContent = textContent.replace(currentPrompt, greentext);
      } else if (findMatchingSubstring(textContent, currentPrompt) !== null) {
        // Highlight the phrase with RGB(38,252,57)
        var greentext =
          '<a style="text-decoration: none; color:' +
          link_color +
          '" ' +
          'href='.concat(link, ' rel="noreferrer" target="_blank">');
        greentext = greentext.concat(
          String(findMatchingSubstring(textContent, currentPrompt)),
          '</a>'
        );
        textContent = textContent.replace(
          findMatchingSubstring(textContent, currentPrompt),
          greentext
        );
      } else {
        let wiki_split = currentPrompt.split(' ');
        let text_content_split = textContent.split(' ');
        let function_words = [
          'a',
          'an',
          'the',
          'and',
          'but',
          'or',
          'for',
          'nor',
          'so',
          'yet',
          'if',
          'of',
          'at',
          'by',
          'in',
          'to',
          'on',
          'not',
        ]; 
        for (let i = 0; i < wiki_split.length; i++) {
          let word = wiki_split[i];
          if (!function_words.includes(word.toLowerCase())) {
            let stripped = word.replace(/[^\w\s]/gi, '');
            for (let n = 0; n < text_content_split.length; n++) {
              if (
                isIsolatedWord(text_content_split[n], wiki_split[i]) &&
                text_content_split[n]
                  .toLowerCase()
                  .includes(wiki_split[i].toLowerCase())
              ) {
                var greentext =
                  '<a style="text-decoration: none; color:' +
                  link_color +
                  '" ' +
                  'href='.concat(link, ' rel="noreferrer" target="_blank">');
                greentext = greentext.concat(
                  String(text_content_split[n]),
                  '</a> '
                );
                text_content_split[n] = greentext;
                break;
              }
              if (
                isIsolatedWord(text_content_split[n], stripped) &&
                text_content_split[n]
                  .toLowerCase()
                  .includes(stripped.toLowerCase())
              ) {
                var greentext =
                  '<a style="text-decoration: none; color:' +
                  link_color +
                  '" ' +
                  'href='.concat(link, ' rel="noreferrer" target="_blank">');
                greentext = greentext.concat(
                  String(text_content_split[n]),
                  '</a> '
                );
                text_content_split[n] = greentext;
                break;
              }
            }
          }
        }
        textContent = text_content_split.join(' ');
      }
      textElement.innerHTML = textContent;
    }
  }
}
//Create and render prompt list
export function getPrompts(
  data,
  currentPrompt,
  currentTile_name,
  ownership,
  currentTile
) {
  if (data.features.length === 0) {
    return;
  }
  document.getElementById('prompt-list').innerHTML = '';

  for (let i = 0; i < data.features.length; i++) {
    var newPrompt = document.createElement('li');
    newPrompt.setAttribute('id', String('box' + i));
    newPrompt.classList.add('prompt-item' + i);

    newPrompt.style.marginTop = '0px';
    newPrompt.style.marginBottom = '8px';
    newPrompt.style.marginRight = '0px';
    newPrompt.style.paddingRight = '10px';

    newPrompt.style.fontFamily = 'Andale Mono, monospace';
    newPrompt.style.fontSize = '13px';
    newPrompt.style.lineHeight = '15px';

    if (ownership === 2) {
      newPrompt.style.color = configuration.yours_sidebar_text_color;
      newPrompt.style.backgroundColor = '#FFD16E';
      newPrompt.style.borderColor = '#FFD16E';
      newPrompt.style.borderRadius = '10px';
      newPrompt.style.borderWidth = '2px';
      newPrompt.style.borderStyle = 'dotted';
    }
    if (ownership === 1) {
      newPrompt.style.color = configuration.owned_sidebar_text_color;
      newPrompt.style.backgroundColor = '#B34040';
      newPrompt.style.borderColor = '#B34040';
      newPrompt.style.borderRadius = '10px';
      newPrompt.style.borderWidth = ' px';
      newPrompt.style.borderStyle = 'dotted';
    }
    if (ownership === 0) {
      newPrompt.style.color = 'rgb(220, 220, 220)';
      newPrompt.style.backgroundColor = '#3b3146';
      newPrompt.style.borderColor = '#3b3146';
      newPrompt.style.borderRadius = '10px';
      newPrompt.style.borderWidth = '2px';
      newPrompt.style.borderStyle = 'dotted';
    }

    newPrompt.style.padding = '10px';

    var pNum = document.createElement('span');
    if (ownership === 2) {
      pNum.style.color = configuration.yours_sidebar_label_color;
    }
    if (ownership === 1) {
      pNum.style.color = configuration.owned_sidebar_label_color;
    }
    pNum.classList.add('prompt-id');
    var promptNum = document.createTextNode(data.features[i].features[0].id);
    pNum.appendChild(promptNum);

    var pText = document.createElement('span');
    var promptText = document.createTextNode(
      '  ' + data.features[i].features[0].properties.img_prompt
    );
    pText.appendChild(promptText);

    let ptext_color = colorWiki(
      pText,
      data.features[i].features[0].properties.wiki,
      currentTile,
      ownership,
    );

    newPrompt.appendChild(pNum);
    newPrompt.appendChild(pText);

    let thisPrompt = [
      data.features[i].features[0].id,
      data.features[i].features[0].properties.img_prompt,
      data.features[i].features[0].geometry,
    ];
    newPrompt.addEventListener('mouseover', (e) => {
      renderPromptBox(thisPrompt, currentTile_name, currentTile);
      let thisBox = document.getElementById(String('box' + i));
      thisBox.style.borderColor = configuration.subtile_hover_color;
      thisBox.style.borderWidth = '2px';
      thisBox.style.borderRadius = '10px';
      thisBox.style.borderStyle = 'solid';
      for (let n = 0; n < data.features.length; n++) {
        if (n !== i) {
          let thisBox = document.getElementById(String('box' + n));
          if (ownership === 2) {
            thisBox.style.borderColor = '#FFD16E';
          }
          if (ownership === 1) {
            thisBox.style.borderColor = '#B34040';
          }
          if (ownership === 0) {
            thisBox.style.borderColor = '#3b3146';
          }
          thisBox.style.borderWidth = '2px';
          thisBox.style.borderRadius = '10px';
          thisBox.style.borderStyle = 'dotted';
          thisBox.style.padding = '10px';
        }
      }
    });
    newPrompt.addEventListener('mouseout', (e) => {
      dissapearPromptBox(thisPrompt, currentTile_name);
      let thisBox = document.getElementById(String('box' + i));
      if (ownership === 2) {
        thisBox.style.borderColor = '#FFD16E';
      }
      if (ownership === 1) {
        thisBox.style.borderColor = '#B34040';
      }
      if (ownership === 0) {
        thisBox.style.borderColor = '#3b3146';
      }
      thisBox.style.borderWidth = '2px';
      thisBox.style.borderRadius = '10px';
      thisBox.style.borderStyle = 'dotted';
      thisBox.style.padding = '10px';
    });

    document.getElementById('prompt-list').appendChild(newPrompt);
  }
}

function getCurrentUrl() {
  let currentUrl = window.location.href;
  return currentUrl;
}

async function getExchangeRate() {
  let USDTOETH;
  const res = await fetch('https://api.coinbase.com/v2/exchange-rates');
  USDTOETH = await res.json();
  USDTOETH = USDTOETH.data.rates.ETH;
  return 1 / USDTOETH;
}

// Hook that alerts clicks outside of the passed ref
function useOutsideAlerter(ref, { setPopout, setSidebar }) {
  const map = useMap();
  useEffect(() => {
    // Alert if clicked on outside of element
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setSidebar(1);
        map.smoothWheelZoom.enable();
        map.dragging.enable();
        setPopout(0);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export default function Popout({
  sidebarTitle,
  masterTile,
  setPopout,
  setSidebar,
  sidebarState,
  setMasterTile,
  gridOverlay,
  setSidebarTitle,
  currentPrompt,
  mintMessage,
  setMintMessage,
  setRevertMessage,
  singleRegion,
  setShowBanner,
  mintingPaused,
  mintingCountdown,
  affiliate,
  setlistViewExpanded,
  setProjectInfo,
  redactNFTs,
  physicalClaimed,
  setphysicalClaimed,
  renderNumber,
  ownership,
  setOwnership,
}) {
  const map = useMap();
  const [promptData, setPrompt] = useState({
    type: 'FeatureCollection',
    features: [{ type: 'FeatureCollection', features: [] }],
  });
  const selectRandomClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
  }) =>
    selectRandom({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
    });
  const selectNextClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    currentTile,
  }) =>
    selectNext({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      currentTile,
    });
  const selectPreviousClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    currentTile,
  }) =>
    selectPrevious({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      currentTile,
    });
  const [ETHTOUSD, setExchange] = useState('');
  const currentTile = masterTile.masterTile;
  const [currentTileOwner, setCurrentTileOwner] = useState('');
  const [listedPrice, setListedPrice] = useState(null);
  const [currentMintPrice, setCurrentMintPrice] = useState(
    Number(currentTile.tokenId) * 250000000000
  );
  const [currentETHPrice, setCurrentETHPrice] = useState(
    (Number(currentTile.tokenId) * 250000000000) / 1000000000000000000
  );
  const [tileLink, setTileLink] = useState('');
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [calcPrice, setCalcPrice] = useState(getPrice(currentTile.tokenId));
  const [isDiscount, setIsDiscount] = useState(false);
  const [posterPath, setPosterPath] = useState('');
  const [videoKey, setVideoKey] = useState(Math.random()); 
  const [pckgExpanded, setpckgExpanded] = useState(true);

  var currentTileSold;
  var tileOwner = '';

  function setLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://opensea.io/assets/ethereum/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://testnets.opensea.io/assets/goerli/';
    }
    let link_with_contract = link_base.concat(String(contractAddress));
    let link2 = link_with_contract.concat('/');
    let full_link = link2.concat(curTile);
    return full_link;
  }
  function setWalletLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://etherscan.io/address/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://goerli.etherscan.io/address/';
    }
    let full_link = link_base.concat(curTile);
    return full_link;
  }
  //Send call to blockchain to determine if user has a discount or not
  async function getMintPrice(tokenId) {
    if (blockchain.account !== '' && blockchain.account !== null) {
      window.contract = await new alch_web3.eth.Contract(
        contractABI,
        contractAddress
      );
      const price = await window.contract.methods
        .getMintPrice(tokenId, blockchain.account)
        .call();

      setCurrentMintPrice(price);
      setCurrentETHPrice(price / 1000000000000000000);
    } else {
      setCurrentMintPrice(Number(tokenId) * 250000000000);
      setCurrentETHPrice(
        (Number(tokenId) * 250000000000) / 1000000000000000000
      );
    }
  }

  //Ownership should be automatically updated and synced across components when wallet is connected in top bar but this is a second check
  // If someone mints a tile while another user is surifng the site they won't see that that tile was bought unless we have this second check when a tile is selected
  // This check gets owner of current tile and only updates ownership dict if it does not match
  const checkOwner = async (tokenId) => {
    const address = String(contractAddress);
    const owner = await alchemy.nft
      .getOwnersForNft(address, tokenId)
      .then((owners) => ownerSuccessHandler(owners))
      .catch((e) => ownerErrorHandler(e));
    setCurrentTileOwner(owner);
  };

  function ownerErrorHandler(e) {
    tileOwner = 'wait';
    if(ownership[sidebarTitle] !== 0){
      const updatedOwnership = {...ownership};
      updatedOwnership[sidebarTitle] = 0;
      setOwnership(updatedOwnership);
    }
    return tileOwner;
  }
  function ownerSuccessHandler(owners) {
    tileOwner = owners['owners'][0];
    if (tileOwner === blockchain.account) {
      if(ownership[sidebarTitle] !== 2){
        const updatedOwnership = {...ownership};
        updatedOwnership[sidebarTitle] = 2;
        setOwnership(updatedOwnership);
      }
    } else {
      if(ownership[sidebarTitle] !== 1){
        const updatedOwnership = {...ownership};
        updatedOwnership[sidebarTitle] = 1;
        setOwnership(updatedOwnership);
      }
    }
    return tileOwner;
  }

  async function fetchPixelPrice() {
    const url = 'https://api.opensea.io/v2/listings/collection/todem/all';
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'X-API-KEY': opensea_key,
      },
    };
    let listings;

    await fetch(url, options)
      .then((res) => res.json())
      .then((json) => (listings = json.listings));
    const PixelPrices = [];
    const ListedTokens = [];
    for (let listing of listings) {
      let listedPrice0 =
        listing.price.current.value / 10 ** listing.price.current.decimals;
      let listedTokenArea =
        listing.protocol_data.parameters.offer[0].identifierOrCriteria;
      ListedTokens.push(listedTokenArea);
      if (listedTokenArea == currentTile.tokenId) {
        setListedPrice(listedPrice0);
      }
    }
    if (ownership[currentTile.tokenId] == 0) {
      //setListedPrice((currentTile.tokenId*0.00000025).toFixed(5));
      setListedPrice(null);
    } else if (
      !ListedTokens.includes(currentTile.tokenId.toString()) &&
      ownership[currentTile.tokenId] !== 0
    ) {
      setListedPrice(null);
    }
  }

  useEffect(() => {
    //setListedPrice(null);
    fetchPixelPrice();
  }, [masterTile]);

  useEffect(() => {
    checkOwner(sidebarTitle);
  }, [masterTile]);

  let minters = [];
  let pageKey;

  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: '',
    SCAN_LINK: '',
    NETWORK: {
      NAME: '',
      SYMBOL: '',
      ID: 0,
    },
    NFT_NAME: '',
    SYMBOL: '',
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: '',
    MARKETPLACE_LINK: '',
    SHOW_BACKGROUND: false,
  });

  map.dragging.disable();
  map.smoothWheelZoom.disable();
  const display_price = getPrice(sidebarTitle);

  function pointInBox(point, box) {
    const x = point[0];
    const y = point[1];
    const left = box[0];
    const top = box[1];
    const right = left + box[2];
    const bottom = top + box[3];
    return x >= left && x < right && y >= top && y < bottom;
  }

  useEffect(() => {
    //Add selection so mousing over prompt shows subtile
    const addInversePromptSelection = (prompt_data) => {
      const video = document.getElementById('popout-video');
      const videoRect = video.getBoundingClientRect();
      const data = prompt_data.features[0];

      var pastSelection = -1;
      const popout = document.getElementsByClassName('popout-left')[0];
      popout.addEventListener('mousemove', (event) => {
        const videoRect = video.getBoundingClientRect();
        let videoAspectRatio =
          currentTile.dimensions[0] / currentTile.dimensions[1];
        let containerAspectRatio = videoRect.width / videoRect.height;

        let contentWidth = 0;
        let contentHeight = 0;
        let leftOffset = 0;
        if (containerAspectRatio > videoAspectRatio) {
          contentHeight = videoRect.height;
          contentWidth = contentHeight * videoAspectRatio;
          leftOffset = (videoRect.width - contentWidth) / 2;
        }
        const x = event.clientX - (videoRect.left + leftOffset);
        const y = event.clientY - videoRect.top;
        var which_box = -1;
        for (let i = 0; i < data.features.length; i++) {
          let thisPrompt = [
            data.features[i].features[0].id,
            data.features[i].features[0].properties.img_prompt,
            data.features[i].features[0].geometry,
          ];
          if (
            pointInBox([x, y], drawSubRegionBox(thisPrompt, currentTile.name))
          ) {
            if (pastSelection !== -1 && pastSelection !== i) {
              const listContainer = document.getElementById('prompt-list');
              const scrollToElement = document.getElementById(
                String('box' + i)
              );
              if (scrollToElement) {
                scrollToElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  inline: 'nearest',
                });
              }

              const past = document.getElementById(
                String('box' + pastSelection)
              );
              const deselect = new MouseEvent('mouseout', {
                view: window,
                bubbles: true,
                cancelable: true,
              });
              if (past) {
                past.dispatchEvent(deselect);
              }
            }

            const element = document.getElementById(String('box' + i));
            const event = new MouseEvent('mouseover', {
              view: window,
              bubbles: true,
              cancelable: true,
            });

            if (element) {
              element.dispatchEvent(event);
            }
            which_box = i;
            pastSelection = i;
          }
        }
        if (which_box === -1 && pastSelection !== -1) {
          const past = document.getElementById(String('box' + pastSelection));
          const deselect = new MouseEvent('mouseout', {
            view: window,
            bubbles: true,
            cancelable: true,
          });
          if (past) {
            past.dispatchEvent(deselect);
          }
        }
      });
    };

    const fetchData = async () => {
      const res = await fetch(
        'https://www.latentculture.com/tohm/galactic-react/src/data/small_geojsons/' +
          masterTile.masterTile.name +
          '.json'
      );
      var prompt_data = await res.json();
      setPrompt(prompt_data);
      addInversePromptSelection(prompt_data);
    };

    const fetchClaimedPhysicals = async () => {
      const res = await fetch(
        'https://www.latentculture.com/logging/galactic-logger/physical_content/' +
          getNum(currentTile.name) +
          '.json'
      ).catch((e) => console.log(e));
      if (res) {
        setphysicalClaimed(true);
      } else {
        setphysicalClaimed(false);
      }
    };

    if (currentTile.tokenId !== 'NaN') {
        if (renderNumber == 42){
          video_path = configuration.path_to_videos_highRes.concat(
            currentTile.name,
            '.mp4'
          );
          setPosterPath(
             `https://www.latentculture.com/tohm/render_${renderNumber}/data/poster/${currentTile.name}.jpg`
          );
        }
        if (renderNumber == 14){
          video_path = configuration.path_to_videos_highRes_14.concat(
            currentTile.name,
            '.mp4'
          );
          setPosterPath(
             `https://www.latentculture.com/tohm/render_${renderNumber}/data/poster/${currentTile.name}.jpg`
          );         
        }
        if (renderNumber == 56){
          video_path = configuration.path_to_videos_highRes_56.concat(
            currentTile.name,
            '.mp4'
          );
          setPosterPath(
             `https://www.latentculture.com/tohm/render_${renderNumber}/data/poster/${currentTile.name}.jpg`
          );        
        }
    } else {
      setPosterPath(``);
    }
    setVideoKey(Math.random());

    if (masterTile.masterTile.name !== 'Click on a tile!') {
      fetchData();
      fetchClaimedPhysicals();
    }
  }, [currentTile, renderNumber]);

  useEffect(() => {
    const getExchangeRate = async () => {
      let USDTOETH;
      const res = await fetch('https://api.coinbase.com/v2/exchange-rates');

      USDTOETH = await res.json();
      USDTOETH = USDTOETH.data.rates.ETH;
      setExchange(1 / USDTOETH);
    };
    getExchangeRate();
  }, [currentTile]);

  async function getRevertReason(txHash) {
    let web3;
    web3 = new Web3(window.ethereum);

    const tx = await web3.eth.getTransaction(txHash);
    try {
      const transaction = await web3.eth.call(tx, tx.blockNumber);
      const receipt = await transaction;
    } catch (e) {
      const err = e.message.toString().split('{')[0];
      setRevertMessage(err);
    }
  }

  // function to get all the minters of the NFT Collection
  // Used to set a mint limit
  async function getMinters() {
    let firstCall = true;

    while (firstCall || pageKey) {
      let res;
      if (pageKey) {
        res = await alchemy.core.getAssetTransfers({
          fromAddress: '0x0000000000000000000000000000000000000000',
          category: ['erc721'],
          contractAddresses: [contractAddress], 
          pageKey: pageKey,
        });
      } else {
        res = await alchemy.core.getAssetTransfers({
          fromAddress: '0x0000000000000000000000000000000000000000',
          category: ['erc721'],
          contractAddresses: [contractAddress], 
        });
      }

      firstCall = false; 
      for (let i = 0; i < res.transfers.length; i++) {
        const transfer = res.transfers[i];
        minters.push(transfer.to); 
      }

      pageKey = res.pageKey; 
    }

    var count_num_mints = 0;
    for (const minter of minters) {
      if (minter === blockchain.account) {
        count_num_mints = count_num_mints + 1;
      }
    }
    return count_num_mints;
  }

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] == value);
  }

  //Mint with ample safety checks
  function mintNFT(tile_to_mint) {
    setCurrentETHPrice(
      (Number(tile_to_mint) * 250000000000) / 1000000000000000000
    );
    getMintPrice(tile_to_mint);
    setCalcPrice(getPrice(tile_to_mint));

    const data = {
      affiliate: affiliate,
      wallet: blockchain.account,
      tilenum: getKeyByValue(token_dict, tile_to_mint),
    };

    getMinters().then((result) => mintHandler(result, tile_to_mint));
  }

  //THis is a triple check. When someone clicks mint we need to make sure no one minted the tile just before them 
  // so they don't end up wasting gas.
  async function checkOwnedSafety(tokenId) {
    if (blockchain.account !== '' && blockchain.account !== null) {
      window.contract = await new alch_web3.eth.Contract(
        contractABI,
        contractAddress
      );
      const isAvail = await window.contract.methods
        .ownerOf(tokenId)
        .call()
        .catch((e) => console.log(e));
      if (isAvail === null || isAvail === undefined || isAvail === '') {
        return true;
      } else {
        return false;
      }
    }
  }

  function mintHandler(num_minted, tile_to_mint) {
    if (num_minted < 100) {
      checkOwnedSafety(tile_to_mint).then((result) =>
        mintGo(result, tile_to_mint)
      );
    } else {
      setMintMessage('over_limit');
      setRevertMessage('Wallet has already minted 100');
    }
  }
  function mintGo(ownerCheck, tile_to_mint) {
    if (ownerCheck) {
      claimNFTs(tile_to_mint);
    } else {
      setMintMessage('err');
      setRevertMessage('Tile already minted');
    }
  }

  const claimNFTs = (tile_to_mint) => {
    let cost = Number(tile_to_mint) * 250000000000; //CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(currentMintPrice); //String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    var proof = null;

    const tree = StandardMerkleTree.load(merkle_tree);
    for (const [i, v] of tree.entries()) {
      if (v[0] === Number(tile_to_mint).toString()) {
        proof = tree.getProof(i);
      }
    }

    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    setMintMessage('minting');
    blockchain.smartContract.methods
      .mint(Number(tile_to_mint), proof)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once('error', (err, receipt) => {
        try {
          setClaimingNft(false);
          setFeedback('Sorry, something went wrong please try again later.');
          getRevertReason(receipt.transactionHash);
          setMintMessage(receipt.transactionHash);
        } catch (e) {
          setMintMessage(null);
        }
      })
      .then((receipt) => {
        setFeedback(
          `The ${CONFIG.NFT_NAME}s are yours, head to the studio to use them.`
        );

        const updatedOwnership = {...ownership};
        updatedOwnership[tile_to_mint] = 2;
        setOwnership(updatedOwnership);

        setCurrentTileOwner(blockchain.account);
        setClaimingNft(false);
        setMintMessage('claimed');
        document.getElementsByClassName('popup')[0].style =
          'background-color: #FEBE32E6;';
        dispatch(fetchData(blockchain.account));

        const data = {
          affiliate: affiliate,
          wallet: blockchain.account,
          tilenum: getKeyByValue(token_dict, tile_to_mint),
        };

        fetch('https://www.latentculture.com/record-affiliate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }).then((response) => response.text());
        // .then(data => console.log(data))
        // .catch((error) => console.error('Error:', error));
      });
  };

  const getData = () => {
    if (blockchain.account !== '' && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    SET_CONFIG(contract);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, { setPopout, setSidebar });

  useEffect(
    () => {
      document.getElementById('prompt-list').innerHTML = '';
      getPrompts(
        promptData.features[0],
        currentPrompt,
        currentTile.name,
        ownership[sidebarTitle],
        currentTile
      );
    },
    [
      currentTile,
      promptData,
      currentPrompt,
      //blockchain.account,
      //currentTileOwner,
      ownership,
    ]
  );
  useEffect(() => {
    setCurrentETHPrice(
      (Number(currentTile.tokenId) * 250000000000) / 1000000000000000000
    );
    getMintPrice(currentTile.tokenId);
    setCalcPrice(getPrice(currentTile.tokenId));
  }, [masterTile]);

  useEffect(() => {
    setCurrentETHPrice(
      (Number(currentTile.tokenId) * 250000000000) / 1000000000000000000
    );
    getMintPrice(currentTile.tokenId);
    setCalcPrice(getPrice(currentTile.tokenId));
  }, [blockchain.account]);

  useEffect(() => {
    if (currentETHPrice.toFixed(8) !== calcPrice.toFixed(8)) {
      setIsDiscount(true);
    } else {
      setIsDiscount(false);
    }
  }, [masterTile, blockchain.account]);

  return (
    <div className="popout">
      <div className="popup" ref={wrapperRef}>
        <div
          className="popout-left"
          style={{
            opacity: 0.85,
            backgroundColor:
              ownership[sidebarTitle] === 2
                ? '#FFCC4B'
                : ownership[sidebarTitle] === 1
                ? configuration.owned_sidebar_background_color
                : configuration.sidebar_background_color,
            borderColor:
              ownership[sidebarTitle] === 2
                ? configuration.yours_sidebar_border_color
                : ownership[sidebarTitle] === 1
                ? configuration.owned_sidebar_border_color
                : configuration.sidebar_border_color,
          }}
        >
          {!redactNFTs ? (
          <>
          
          <TokenProgress
            tokenId={currentTile.tokenId}
            tileClass={currentTile.name[5]}
          >
          </TokenProgress>
          
          </>
          ) : null}

          <div
            className="popout-vid-container"
            style={{
              opacity: 0.85,
              backgroundColor:
                ownership[sidebarTitle] === 2
                  ? '#FFCC4B'
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_background_color
                  : configuration.sidebar_background_color,
              borderColor:
                ownership[sidebarTitle] === 2
                  ? configuration.yours_sidebar_border_color
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_border_color
                  : configuration.sidebar_border_color,
            }}
          >
            <div className="subregion-helper-popout">
              <div className="vid-formatter">
                <div className="subregion-video-box-popout"></div>
                <video
                  key={videoKey}
                  id="popout-video"
                  className="icon popout-video2"
                  autoPlay
                  playsInline
                  muted
                  loop
                  poster={posterPath}
                  src={video_path}
                  type="video/mp4"
                ></video>
              </div>
            </div>
          </div>
          <div
            className="popout-nav"
            style={{
              opacity: 0.85,
              backgroundColor:
                ownership[sidebarTitle] === 2
                  ? '#FFCC4B'
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_background_color
                  : configuration.sidebar_background_color,
              borderColor:
                ownership[sidebarTitle] === 2
                  ? configuration.yours_sidebar_border_color
                  : ownership[sidebarTitle] === 1
                  ? configuration.owned_sidebar_border_color
                  : configuration.sidebar_border_color,
            }}
          >
            <div
              className="popout-nav-item popout-last-button"
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_buttons_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_buttons_color
                    : configuration.sidebar_buttons_color,
              }}
              onClick={() => {
                let shouldZoom = 1;
                selectPreviousClone({
                  map,
                  gridOverlay,
                  sidebarState,
                  setMasterTile,
                  setSidebarTitle,
                  shouldZoom,
                  currentTile,
                });
              }}
            >
              <IoIosArrowBack className="icon" style={{ fontSize: 22 }} />
            </div>
            <div
              className="popout-nav-item popout-shuffle"
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_buttons_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_buttons_color
                    : configuration.sidebar_buttons_color,
              }}
              onClick={() => {
                setSidebar(1);
                let shouldZoom = 1;
                selectRandomClone({
                  map,
                  gridOverlay,
                  sidebarState,
                  setMasterTile,
                  setSidebarTitle,
                  shouldZoom,
                });
              }}
            >
              <TiArrowShuffle className="icon" style={{ fontSize: 22 }} />
            </div>
            <div
              className="popout-nav-item popout-next-button"
              style={{
                color:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_buttons_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_buttons_color
                    : configuration.sidebar_buttons_color,
              }}
              onClick={() => {
                let shouldZoom = 1;
                selectNextClone({
                  map,
                  gridOverlay,
                  sidebarState,
                  setMasterTile,
                  setSidebarTitle,
                  shouldZoom,
                  currentTile,
                });
              }}
            >
              <IoIosArrowForward style={{ fontSize: 22 }} className="icon" />
            </div>
          </div>
        </div>

        <div
          id="popout-grid-container-container2"
          style={{
            backgroundColor:
              ownership[sidebarTitle] === 2
                ? configuration.yours_sidebar_base_color
                : ownership[sidebarTitle] === 1
                ? configuration.owned_sidebar_base_color
                : configuration.sidebar_base_color,
          }}
        >
          <div className="popout-grid-container2">
            <div
              className="popout-grid-item2 popout-grid-item-1"
              style={{
                opacity: 1,
                backgroundColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_background_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_background_color
                    : configuration.sidebar_background_color,
                borderColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_border_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_border_color
                    : configuration.sidebar_border_color,
              }}
            >
              <div
                className="popout-close"
                onClick={() => {
                  map.smoothWheelZoom.enable();
                  map.dragging.enable();
                  var popout = document.getElementsByClassName('popout')[0];
                  popout.style.animation = 'fadePopoutOut 0.35s';
                  setTimeout(() => {
                    setPopout(0);
                  }, 340);
                  setTimeout(() => {
                    setSidebar(1);
                  }, 340);
                }}
                style={{
                  color:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_buttons_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_buttons_color
                      : configuration.sidebar_buttons_color,
                }}
              >
                <IoIosClose className="icon" style={{ fontSize: 90 }} />
              </div>
              <div
                id="popout-sidebartitle2"
                style={{
                  color:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_text_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_text_color
                      : configuration.sidebar_text_color,
                }}
              >
                {getNum(currentTile.name)}
              </div>
              <div
                className="popout-copy"
                style={{
                  color:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_buttons_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_buttons_color
                      : configuration.sidebar_buttons_color,
                }}
                onClick={() => {
                  var currentUrl = window.location.href;
                  navigator.clipboard.writeText(currentUrl);

                  var copy = document.getElementById('feedback-container');
                  if (copy) {
                    // Clear previous timeouts if any.
                    if (copyFadeOutTimer) {
                      clearTimeout(copyFadeOutTimer);
                    }
                    if (copyHideTimer) {
                      clearTimeout(copyHideTimer);
                    }

                    copy.style.display = 'block';
                    copy.style.opacity = 1;
                    // Start fading out after 3 seconds.
                    copyFadeOutTimer = setTimeout(() => {
                      copy.style.transition = 'opacity 1s ease-out';
                      copy.style.opacity = 0;
                      // Start hiding after 1 more second.
                      copyHideTimer = setTimeout(() => {
                        copy.style.display = 'none';
                      }, 1000);
                    }, 3000);
                  }
                }}
              >
                <IoCopyOutline
                  className="icon"
                  id="close-icon"
                  style={{ fontSize: 22 }}
                />
              </div>
            </div>

            <div
              className="tile-info-flexbox popout-grid-item2 popout-grid-item-52"
              style={{
                opacity: 1,
                backgroundColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_background_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_background_color
                    : configuration.sidebar_background_color,
                borderColor:
                  ownership[sidebarTitle] === 2
                    ? configuration.yours_sidebar_border_color
                    : ownership[sidebarTitle] === 1
                    ? configuration.owned_sidebar_border_color
                    : configuration.sidebar_border_color,

                maxHeight: redactNFTs ? 'unset' : 'calc(100dvh - 217px)',
              }}
            >
              <div className="popout-tile-details">
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      token id{' '}
                    </span>
                  </div>

                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {' '}
                      {currentTile.tokenId}{' '}
                    </span>
                  </div>
                </div>
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      dimensions{' '}
                    </span>
                  </div>
                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {currentTile.dimensions[0]} x {currentTile.dimensions[1]}
                    </span>
                  </div>
                </div>
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      pixels{' '}
                    </span>
                  </div>
                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {parseInt(currentTile.tokenId) >= 100000000
                        ? '100,000,000+'
                        : parseInt(currentTile.tokenId) >= 10000000
                        ? '10,000,000+'
                        : parseInt(currentTile.tokenId) >= 1000000
                        ? '1,000,000+'
                        : parseInt(currentTile.tokenId) >= 100000
                        ? '100,000+'
                        : parseInt(currentTile.tokenId) >= 10000
                        ? '10,000+'
                        : parseInt(currentTile.tokenId) >= 1000
                        ? '1,000+'
                        : null}
                    </span>
                  </div>
                </div>
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      label{' '}
                    </span>
                  </div>
                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {getLabel(currentTile)}
                    </span>{' '}
                    {/* {currentTile.name[5]} */}
                  </div>
                </div>
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      triptych{' '}
                    </span>
                  </div>
                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {getTriptych(currentTile)}
                    </span>
                  </div>
                </div>
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      class{' '}
                    </span>
                  </div>

                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        fontWeight: 100,
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {' '}
                      {currentTile.name[5]}
                    </span>
                  </div>
                </div>
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      subtiles{' '}
                    </span>
                  </div>
                  <div className="tile-info-grid-metadata-right">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_text_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_text_color
                            : configuration.sidebar_text_color,
                      }}
                    >
                      {' '}
                      {promptData.features[0].features.length}
                    </span>{' '}
                    {/* {currentTile.name[5]} */}
                  </div>
                </div>
              </div>
              <div className="popout-prompt-details">
                <div className="tile-info-grid-metadata">
                  <div className="tile-info-grid-metadata-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      {' '}
                      prompts{' '}
                    </span>
                  </div>
                  <div
                    className="tile-info-grid-metadata-right popout-metadata-prompt"
                    style={{
                      height: redactNFTs
                        ? 'calc(100dvh - 388px)'
                        : currentETHPrice.toFixed(8) !== calcPrice.toFixed(8) &&
                          ownership[sidebarTitle] === 0
                        ? 'calc(100dvh - 388px - 105px)'
                        : 'calc(100dvh - 388px - 80px)',
                    }}
                  >
                    <ul id="prompt-list"></ul>
                  </div>
                </div>
              </div>
            </div>

            {redactNFTs ? null : (
              <div
                className="popout-grid-item5"
                style={{
                  opacity: 1,
                  backgroundColor:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_background_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_background_color
                      : configuration.sidebar_background_color,
                  borderColor:
                    ownership[sidebarTitle] === 2
                      ? configuration.yours_sidebar_border_color
                      : ownership[sidebarTitle] === 1
                      ? configuration.owned_sidebar_border_color
                      : configuration.sidebar_border_color,
                }}
              >
                <div className="pricing">
                  <div className="pricing-left">
                    <span
                      style={{
                        color:
                          ownership[sidebarTitle] === 2
                            ? configuration.yours_sidebar_label_color
                            : ownership[sidebarTitle] === 1
                            ? configuration.owned_sidebar_label_color
                            : configuration.sidebar_label_color,
                      }}
                    >
                      price{' '}
                    </span>
                  </div>
                  {!ownership[currentTile.tokenId] ? (
                    <div className="pricing-right">
                      <div className="flex-column-popout">
                        {currentETHPrice.toFixed(8) !== calcPrice.toFixed(8) ? (
                          <span
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_text_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_text_color
                                  : configuration.sidebar_text_color,
                            }}
                          >
                            <del>
                              {getPrice(currentTile.tokenId).toFixed(5)}
                            </del>{' '}
                            eth <br></br> {currentETHPrice.toFixed(5)} eth
                          </span>
                        ) : (
                          <span
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_text_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_text_color
                                  : configuration.sidebar_text_color,
                            }}
                          >
                            {currentETHPrice.toFixed(5)} eth
                          </span>
                        )}
                      </div>
                      <div
                        className="flex-column-popout"
                        style={{ paddingRight: '2em' }}
                      >
                        {currentETHPrice.toFixed(8) !== calcPrice.toFixed(8) ? (
                          <span
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_usd_price_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_usd_price_color
                                  : configuration.sidebar_usd_price_color,
                            }}
                          >
                            (
                            <del>
                              <NumericFormat
                                style={{
                                  color:
                                    ownership[sidebarTitle] === 2
                                      ? configuration.yours_sidebar_usd_price_color
                                      : ownership[sidebarTitle] === 1
                                      ? configuration.owned_sidebar_usd_price_color
                                      : configuration.sidebar_usd_price_color,
                                }}
                                value={(
                                  getPrice(currentTile.tokenId) * ETHTOUSD
                                ).toFixed(2)}
                                displayType="text"
                                thousandSeparator=","
                                prefix={'$'}
                              />
                            </del>
                            )<br></br> ($
                            {(currentETHPrice * ETHTOUSD).toFixed(2)})
                          </span>
                        ) : (
                          <span
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_usd_price_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_usd_price_color
                                  : configuration.sidebar_usd_price_color,
                            }}
                          >
                            (
                            <NumericFormat
                              style={{
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_usd_price_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_usd_price_color
                                    : configuration.sidebar_usd_price_color,
                              }}
                              value={(
                                getPrice(currentTile.tokenId) * ETHTOUSD
                              ).toFixed(2)}
                              displayType="text"
                              thousandSeparator=","
                              prefix={'$'}
                            />
                            )<br></br>
                          </span>
                        )}
                      </div>
                    </div>
                  ) : (
                    <>
                      {listedPrice === null ? (
                        <div className="pricing-right">
                          <span
                            style={{
                              color:
                                ownership[sidebarTitle] === 2
                                  ? configuration.yours_sidebar_text_color
                                  : ownership[sidebarTitle] === 1
                                  ? configuration.owned_sidebar_text_color
                                  : configuration.sidebar_text_color,
                            }}
                          >
                            {' '}
                            -{' '}
                          </span>
                        </div>
                      ) : (
                        <div className="pricing-right">
                          <div className="flex-column-popout">
                            <span
                              style={{
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_usd_price_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_usd_price_color
                                    : configuration.sidebar_usd_price_color,
                              }}
                            >
                              {parseFloat(listedPrice).toFixed(5)} eth
                            </span>
                          </div>
                          <div className="flex-column-popout">
                            <span
                              style={{
                                opacity: 0.25,
                                color:
                                  ownership[sidebarTitle] === 2
                                    ? configuration.yours_sidebar_usd_price_color
                                    : ownership[sidebarTitle] === 1
                                    ? configuration.owned_sidebar_usd_price_color
                                    : configuration.sidebar_usd_price_color,
                              }}
                            >
                              (
                              <NumericFormat
                                style={{
                                  color:
                                    ownership[sidebarTitle] === 2
                                      ? configuration.yours_sidebar_usd_price_color
                                      : ownership[sidebarTitle] === 1
                                      ? configuration.owned_sidebar_usd_price_color
                                      : configuration.sidebar_usd_price_color,
                                }}
                                value={(listedPrice * ETHTOUSD).toFixed(2)}
                                displayType="text"
                                thousandSeparator=","
                                prefix={'$'}
                              />
                              )
                            </span>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {!ownership[currentTile.tokenId] ? (
                    <div className="popout-minting">
                      {mintingPaused ? (
                        <div
                          id="connect"
                          style={{ backgroundColor: 'lightgray' }}
                          onClick={(e) => {
                            setShowBanner(1);

                            if (mintingCountdown === 1) {
                              var minting =
                                document.getElementsByClassName(
                                  'mint-countdown'
                                )[0];
                              if (minting.classList.contains('shake')) {
                                minting.classList.remove('shake');
                                void minting.offsetWidth; // trigger a DOM reflow
                              }
                              minting.classList.add('shake');
                            }
                          }}
                        >
                          mint
                        </div>
                      ) : (
                        <>
                          {blockchain.account === '' ||
                          blockchain.smartContract === null ? (
                            <div
                              id="connect"
                              onClick={(e) => {
                                setMintMessage('no_wallet');
                                setRevertMessage(
                                  'Connect your ethereum wallet via the connect wallet dropdown before minting'
                                );
                              }}
                            >
                              mint
                            </div>
                          ) : (
                            <div
                              id="connect"
                              style={{
                                marginLeft: claimingNft ? '-50px' : '0px',
                                opacity: 1,
                                backgroundColor: 'rgb(134, 201, 154)',
                              }}
                              disabled={claimingNft ? 1 : 0}
                              onClick={(e) => {
                                e.preventDefault();
                                mintNFT(currentTile.tokenId);
                                getData();
                              }}
                            >
                              {claimingNft ? 'processing' : 'mint'}
                            </div>
                          )}
                        </>
                      )}
                      <img
                        src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"
                        alt="Opensea Icon"
                        id="opensea"
                        style={{
                          opacity: 0.2,
                          filter: 'grayscale(100%)',
                          pointerEvents: 'none',
                        }}
                        onClick={() => {
                          //window.open(setLink(currentTile.tokenId), '_blank');
                        }}
                      ></img>
                    </div>
                  ) : (
                    <div
                      className="popout-minting"
                      style={{
                        right:
                          currentTileOwner === blockchain.account && ownership[sidebarTitle] === 2
                            ? 'calc(-10px + -7em)'
                            : 'calc(-10px + -10%)',
                      }}
                    >
                      {currentTileOwner === blockchain.account && ownership[sidebarTitle] === 2 &&
                      (currentTile.name[5] == 'B' ||
                        currentTile.name[5] == 'A') ? (
                        <div
                          id="popout-connect"
                          style={{
                            opacity: physicalClaimed ? 0.3 : 1.0,
                            backgroundColor: physicalClaimed
                              ? 'lightgray'
                              : '#8CCEFF',
                            display: 'inline-block',
                            width: 'fit-content',
                            marginLeft: '-210px',
                            marginRight: '10px',
                          }}
                        >
                          {!physicalClaimed ? (
                            <span
                              class="pckg"
                              style={{
                                textDecoration: 'none',
                                fontFamily: 'Terminus',
                                fontStyle: 'normal',
                                cursor: 'pointer',
                                color: configuration.yours_sidebar_text_color,
                                display: 'inline-block',
                              }}
                              onClick={() => {
                                setMintMessage('claim_physical');
                              }}
                            >
                              claim physical
                            </span>
                          ) : (
                            <span
                              style={{
                                textDecoration: 'none',
                                fontFamily: 'Terminus',
                                fontStyle: 'normal',
                                cursor: 'default',
                                color: configuration.yours_sidebar_text_color,
                                display: 'inline-block',
                              }}
                            >
                              physical claimed
                            </span>
                          )}
                        </div>
                      ) : null}

                      <div
                        id="popout-connect"
                        onClick={() => {
                          if (currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2) {
                            window.open(
                              setWalletLink(currentTileOwner),
                              '_blank'
                            );
                          } else {
                            window.open(constructIPFSLink(currentTile), '_blank');
                          }
                        }}
                        style={{
                          opacity:
                            currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2 ? 0.3 : 1.0,
                          backgroundColor:
                            currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2
                              ? 'lightgray'
                              : '#8CCEFF',
                          display: 'inline-block',
                          width: 'fit-content',
                          marginLeft:
                            currentTileOwner !== blockchain.account || ownership[sidebarTitle] !== 2
                              ? '-80px'
                              : parseInt(getNum(currentTile.name)) <= 99
                              ? '0px'
                              : '-80px',
                        }}
                      >
                        {currentTileOwner === blockchain.account && ownership[sidebarTitle] === 2 ? (
                          <span
                            class="pckg"
                            style={{
                              textDecoration: 'none',
                              fontFamily: 'Terminus',
                              fontStyle: 'normal',
                              cursor: 'pointer',
                              color: configuration.yours_sidebar_text_color,
                              display: 'inline-block',
                            }}
                            onClick={() => {
                              window.open(constructIPFSLink(currentTile), '_blank');
                            }}
                          >
                            PCKG
                            <CgSoftwareDownload
                              className="icon"
                              style={{
                                fontSize: 20,
                                paddingBottom: '3px',
                                marginRight: '-4px',
                              }}
                            />
                          </span>
                        ) : (
                          <>
                            <span>{currentTileOwner.substring(0, 6)}</span>
                            <span>...</span>
                            <span>{currentTileOwner.slice(-4)}</span>
                          </>
                        )}
                      </div>
                      <img
                        src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"
                        alt="Opensea Icon"
                        id="opensea"
                        style={{ opacity: 1 }}
                        onClick={() => {
                          window.open(setLink(currentTile.tokenId), '_blank');
                        }}
                      ></img>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
